<ion-content>
   <app-header [isParentPage]="false" [title]="'Order ID #'+ (order?.webOrder?.woId || '')"></app-header>

  <div class="modal-container" style="padding-top:70px">
    <div class="title">

      <div class="spacer"></div>
    </div>
    <div class="cancel-container">
       <ion-row>
         <div class="top-header-row" style="width:60%">
            <div class="image-container" style="width:300px">
                <img src="./assets/images/gallagher logo_h.png" alt="Gallagher Image"  style="width: 500px;margin-top: 20px;margin-left: 30px;"/>
            </div>
          </div>
                <ion-grid class="inner-grid right-align">
                    <ion-row class="header-line-item">
                        <ion-col ><b>Order ID:</b>{{ order?.webOrder?.woId }}</ion-col>
                         <ion-col class="header-line-item">
                     <button class="printer-button code hidden-for-print" style=" color: blue;text-decoration: underline;cursor: pointer;" (click)="changePrinterView()">Print</button>
                         </ion-col>
                    </ion-row>
                     <ion-row>
                        <ion-col ><b>Order Type: </b>&nbsp;&nbsp;{{ order?.orderType }} </ion-col>
                     </ion-row>
                      <ion-row>
                        <ion-col size="auto"><b>Date:  </b> {{order?.webOrder?.enteredDate | date : "MM/dd/yyyy"}}</ion-col>
                    </ion-row>
                    <ion-row>
                          <ion-col><b>Order For:</b> &nbsp;&nbsp;
                          {{ order.webOrder.customerCode }}
                          {{ order.webOrder.departmentCode }}
                          {{ order.webOrder.employeeCode }}
                          {{ order.webOrder.firstName }} {{ order.webOrder.lastName }}  </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-row>

    </div>
       <hr style="border: 1px solid black; width: 100%;margin:0px;margin: 0px;height: 0px;">
      <ion-row>
          <ion-col><b>Email: </b>&nbsp;&nbsp;{{order.webOrder.email}}</ion-col>
          <ion-col size="auto"><b>State: </b> {{order.state}}</ion-col>
     </ion-row>
    <div class="table">
      <ion-row>
        <ion-col>
          <ion-row class="table-titles" style="background-color: #ccffcc">
            <ion-col *ngIf="order.webOrder.orderType === 'repGar'" size="3">
              <ion-label>Garment</ion-label>
            </ion-col>
            <ion-col *ngIf="order.webOrder.orderType !== 'repGar'" size="1">
              <ion-label>Item</ion-label>
            </ion-col>
            <ion-col size="3">
              <ion-label>Product Code</ion-label>
            </ion-col>
            <ion-col size="3">
              <ion-label>Description</ion-label>
            </ion-col>
            <ion-col *ngIf="order.webOrder.orderType !== 'repGar'" size="1">
              <ion-label>Qty</ion-label>
            </ion-col>
            <ion-col *ngIf="order.webOrder.orderType !== 'repGar'" size="2">
              <ion-label>Old Size</ion-label>
            </ion-col>
            <ion-col *ngIf="order.webOrder.orderType !== 'repGar'" size="2">
              <ion-label>New Size</ion-label>
            </ion-col>
            <ion-col *ngIf="order.webOrder.orderType === 'repGar'" size="3">
              <ion-label>Reason</ion-label>
            </ion-col>
          </ion-row>
          <ng-container *ngIf="order.webOrder.orderType === 'repGar'">
            <ion-row class="table-row" *ngFor="let item of order.webGarments">
              <ion-col size="3">
                <ion-label>{{ item.garmentCode }}</ion-label>
              </ion-col>
              <ion-col size="3">
                <ion-label>{{ item.productCode }}</ion-label>
              </ion-col>
              <ion-col size="3">
                <ion-label>{{ item.name }}</ion-label>
              </ion-col>
              <ion-col size="3">
                <ion-label>{{ item.description && item.description.trim() !== '' ? item.description : 'Replacement' }}</ion-label>
              </ion-col>
            </ion-row>
          </ng-container>
          <ng-container *ngIf="order.webOrder.orderType !== 'repGar'">
            <ion-row class="table-row" *ngFor="let item of order.webOrderItems">
              <ion-col size="1">
                <ion-label>{{ item.itemId }}</ion-label>
              </ion-col>
              <ion-col size="3">
                <ion-label>{{ item.productCode }}</ion-label>
              </ion-col>
              <ion-col size="3">
                <ion-label>{{ item.description }}</ion-label>
              </ion-col>
              <ion-col size="1">
                <ion-label>{{ item.qty }}</ion-label>
              </ion-col>
              <ion-col size="2">
                <ion-label>{{ item.oldSize1 }} {{item.oldSize2}}</ion-label>
              </ion-col>
              <ion-col size="2">
                <ion-label>{{ item.newSize1 }} {{item.newSize2}}</ion-label>
              </ion-col>
            </ion-row>
          </ng-container>
        </ion-col>
      </ion-row>
    </div>
  </div>
</ion-content>
